// NOTE Consider changing the casing to be all caps?
export const DATE_DISPLAY_FORMAT = 'MM/DD/YYYY';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const REGULAR_SEASON_ID = 2;
export const PLAYOFFS_ID = 3;
export const GAME_TYPE_IDS = [REGULAR_SEASON_ID, PLAYOFFS_ID];
/* Season years of important NHL stats collecting events.
   The years below are the cutoff years for certain sets of data that we have
   i.e. we only have data for playoff save percetanges for any year over 1955
*/
export const YEAR_LEAGUE_STARTED_RECORDING = {
    // Playoff save percentages
    playoffSaves: 19551956,
    // Goals allowed and saves by goalie
    goalieStats: 19551956,
    regSeasonSavePercentage: 19551956,
    // Time on ice, shifts per game, ev/pp/sh save percentage
    timeOnIce: 19971998,
};

export default {
    DATE_DISPLAY_FORMAT,
    DATE_FORMAT,
    REGULAR_SEASON_ID,
    PLAYOFFS_ID,
    GAME_TYPE_IDS,
    YEAR_LEAGUE_STARTED_RECORDING,
};
